export const TEXT_ALIGN_LIST = ['left', 'center', 'right'];

export type TextAlign = typeof TEXT_ALIGN_LIST[number];
